var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('with-title',{attrs:{"title":_vm.$t('video.views'),"subtitle":_vm.videos.length.toString()}},[_c('video-gallery',{attrs:{"videos":_vm.videos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }